import React, { useEffect } from "react";
import { Button, Card, Col, Collapse, Divider, Row, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import PolicyContent from "./PolicyContent";
import { checkPermission } from "../../../Helpers/Functions";
const { Panel } = Collapse;

const Policy = ({policies , responcess, getClientDetail}) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="flex justify-between items-center my-5">
        <div className="flex gap-5 mr-[10px]">
          <div className="font-semibold">Associated Agent</div>
          <div className="">{policies[0]?.insurance?.agent_name} (NPN - {policies[0]?.insurance?.agent_npn ? policies[0]?.insurance?.agent_npn : "N/A"})</div>
        </div>
        {checkPermission('manage_request', 'raise-request') && <div>
          <Button type="primary" onClick={() => navigate("/raise-request-client")}>
            Raise a request
          </Button>
        </div>}
      </div>
      <PolicyContent policies={policies} responcess={responcess} getClientDetail = {getClientDetail} />
    </>
  );
};

export default Policy;
